var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeralatan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 82.5,
    r: 82.5,
    fill: "#BD1E26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.676 70.5346L98.7893 80.4192L89.8045 71.4318L99.6891 61.5473C96.6731 60.3074 93.3577 59.9877 90.1604 60.6283C86.9631 61.2689 84.0268 62.8412 81.7213 65.1472C79.4158 67.4533 77.8441 70.39 77.2043 73.5874C76.5644 76.7849 76.885 80.1002 78.1256 83.1159L62.1741 99.0648C61.9378 99.3007 61.7504 99.5808 61.6225 99.8891C61.4947 100.197 61.4288 100.528 61.4288 100.862C61.4288 101.196 61.4947 101.526 61.6225 101.834C61.7504 102.143 61.9378 102.423 62.1741 102.659L67.5675 108.052C67.8033 108.288 68.0834 108.476 68.3917 108.604C68.7001 108.732 69.0306 108.797 69.3644 108.797C69.6982 108.797 70.0288 108.732 70.3371 108.604C70.6454 108.476 70.9256 108.288 71.1614 108.052L87.1103 92.1007C90.1263 93.3422 93.4422 93.6635 96.6404 93.0239C99.8386 92.3844 102.776 90.8127 105.082 88.5068C107.388 86.1997 108.959 83.2623 109.598 80.0644C110.238 76.8664 109.917 73.5507 108.676 70.5346Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeralatan);
export default __webpack_public_path__ + "static/media/peralatan.effb6f838aada19d9c40b241c8aec010.svg";
export { ForwardRef as ReactComponent };